import React, { forwardRef } from "react";
import HTMLFlipBook from "react-pageflip";
import "../css/FlipBooks.css";

const Page = forwardRef(({ children, className }, ref) => (
  <div ref={ref} className={`page ${className}`}>
    {children}
  </div>
));

const Flipbooks = ({ data }) => {
  return (
    <HTMLFlipBook width={300} height={500} showCover={true}>
      <div>
        {/* Cover Page */}
        <Page className="hard">
          <h1>Portfolio</h1>
        </Page>
      </div>
      <div>
        <Page style={{ background: " #601945" }}>
          <h1></h1>
        </Page>
      </div>
      {/* Table of Contents */}
      <div>
        <Page>
          <h2>Table of Contents</h2>
          <ul className="table-of-contents">
            {data.map((item, index) => (
              <div key={`toc-fragment-${index}`}>
                <li key={`toc-item-${index}`}>
                  {index + 1}.{" "}
                  {item.eventId ? item.eventId.name || "No Name" : "No Name"}
                </li>
                <br />
              </div>
            ))}
          </ul>
        </Page>
      </div>
      {/* Content Pages */}
      {data.map((item, index) => (
        <div key={`content-fragment-${index}`}>
          <Page key={`content-${index}`}>
            <h2 className="page-title">
              {item.eventId ? item.eventId.name || "No Name" : "No Name"}
            </h2>
            <p
              className="page-description"
              dangerouslySetInnerHTML={{
                __html: item.eventId
                  ? item.eventId.description || "No Description"
                  : "No Description",
              }}
            />
            <footer className="page-footer">Page {index + 3}</footer>
          </Page>
        </div>
      ))}
    </HTMLFlipBook>
  );
};

export default Flipbooks;
